import Vue from 'vue';
export default Vue.component('showMe', {
    props: {
        icon: String,   // optional, the button icon to display 
        text: String,   // optional, text as an alternative to an icon
        image: String,  // the (animated gif) image to display in the dialog, just the main file name, ie "xx" in "./xx.gif"
        title: String,  // the title for the dialog when displayed
        bold: Boolean,  // whether to display as a chip instead of a button, for obviousness
        small: Boolean  // whether to display small (e.g. for inline)
    },
    data: function() {
        return {
            btnIcon: this.text ? "" : this.icon || 'mdi-message-video',
            smText: this.text,
            imgPath: `./${this.image}.gif`,
            wrapperComponent: this.bold || this.text ? 'v-chip' : 'v-btn'
        }
    }
})